import * as actions from '../actions/amenity-collection';
import * as models from '../../domain/models';

export interface State {
  loaded: boolean;
  loading: boolean;
  items: Array<models.AircraftAmenity>;
}

const initialState: State = {
  loaded: false,
  loading: false,
  items: [],
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return { ...state, loading: true };
    }

    case actions.LOAD_SUCCESS: {
      return {
        loaded: true,
        loading: false,
        items: action.payload,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        loaded: true,
        loading: true,
        items: [],
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.loaded;
export const getIsLoading = (state: State) => state.loading;
export const getItems = (state: State) => state.items;
